<template>
    <div id="institution_c">
        <div style="height: 120px;border-bottom: 2px dashed #eee">
            <el-row>
                <el-col>
                    <span class="demonstration" style="border-radius: 5px;margin-right: 15px">年月</span>
                    <el-date-picker
                            style="width: 160px;margin-right: 50px"
                            v-model="value2"
                            type="month"
                            placeholder="选择月">
                    </el-date-picker>
                    <span class="demonstration" style="margin-right: 15px">
                类型
            </span>
                    <el-select style="width: 160px" v-model="value" placeholder="请选择" value="">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                    <div style="float: right">
                        <span style="margin-right: 15px">人员</span>
                        <inputSelect :handleSelectInput="handleSelectInputClick"></inputSelect>
                    </div>
                </el-col>
                <el-col span="24" style="margin-top: 24px">
                    <el-button type="primary" size="small" @click="searchWeekList"
                               style="background: #4EC880;border: none">
                        查询
                    </el-button>
                    <el-button type="danger" size="small" @click="ResetClick"
                               style="background: #D0021B;border: none">
                        重置
                    </el-button>
                </el-col>
            </el-row>
        </div>
        <el-row style="margin-top: 20px">
            <el-col span="24"><span style="font-size: 18px;">2019年9月</span></el-col>
            <el-col span="7">
                <div  >
                    <p>
                        <span style="font-size: 12px;display: inline-block;width: 120px;color: #909399">目标经销商总数</span>
                        <span>155人</span>
                    </p>
                    <p>
                        <span style="font-size: 12px;display: inline-block;width: 120px;color: #909399">拜访覆盖数</span>
                        <span style="color:#FF9901 ">134人</span>
                    </p>
                </div>
            </el-col>
            <el-col span="1" style="border: 1px transparent solid;">
                <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">

                </div>
            </el-col>
            <el-col span="7">
                <div style="width: 100%;height: 100%;box-sizing: border-box" >
                    <ul style="width: 100%;max-width: 300px;margin: auto">
                        <li style="margin-top: 16px;overflow: hidden;width: 100%">
                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                A类
                            </div>
                            <div style="float: left;width: calc(100% - 50px)">
                                <el-progress  :stroke-width="20" color="#7ED321" :percentage="98"
                                              style="margin-bottom: 5px;width: 100%">
                                </el-progress>
                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>
                            </div>
                        </li>
                        <li style="margin-top: 16px;overflow: hidden;width: 100%">
                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                A类
                            </div>
                            <div style="float: left;width: calc(100% - 50px)">
                                <el-progress  :stroke-width="20" color="#FF9901" :percentage="78"
                                              style="margin-bottom: 5px;width: 100%">
                                </el-progress>
                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>
                            </div>
                        </li>
                        <li style="margin-top: 16px;overflow: hidden;width: 100%">
                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                A类
                            </div>
                            <div style="float: left;width: calc(100% - 50px)">
                                <el-progress  :stroke-width="20" color="#7ED321" :percentage="90"
                                              style="margin-bottom: 5px;width: 100%">
                                </el-progress>
                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>
                            </div>
                        </li>
                        <li style="margin-top: 16px;overflow: hidden;width: 100%">
                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">
                                A类
                            </div>
                            <div style="float: left;width: calc(100% - 50px)">
                                <el-progress color="#ED3B3F" :stroke-width="20"  :percentage="50"
                                              style="margin-bottom: 5px;width: 100%">
                                </el-progress>
                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>
                            </div>
                        </li>

                    </ul>
                    <!--                    <div style="width: 100%;">-->
                    <!--                        <div style="width: 50px;height: 20px;float: left;line-height: 20px">-->
                    <!--                            A类-->
                    <!--                        </div>-->
                    <!--                        <div style="float: left;width: cale(100%);position: absolute;margin-left: 50px">-->
                    <!--                            <el-progress  :stroke-width="20"  :percentage="98"-->
                    <!--                                         style="margin-bottom: 5px;width: 100%">-->
                    <!--                            </el-progress>-->
                    <!--                            <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                </div>
            </el-col>

<!--            <el-col span="1" style="border: 1px transparent solid;"></el-col>-->
<!--            <el-col style="margin-bottom: 15px" span="7">-->
<!--                <div style="width: 100%;height: 100%">-->
<!--                    <ul style="width: 100%;max-width: 300px;margin: auto">-->
<!--                        <li style="margin-top: 16px;overflow: hidden;width: 100%">-->
<!--                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">-->
<!--                                A类-->
<!--                            </div>-->
<!--                            <div style="float: left;width: calc(100% - 50px)">-->
<!--                                <el-progress  :stroke-width="20"  :percentage="98"-->
<!--                                              style="margin-bottom: 5px;width: 100%">-->
<!--                                </el-progress>-->
<!--                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li style="margin-top: 16px;overflow: hidden;width: 100%">-->
<!--                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">-->
<!--                                A类-->
<!--                            </div>-->
<!--                            <div style="float: left;width: calc(100% - 50px)">-->
<!--                                <el-progress  :stroke-width="20"  :percentage="98"-->
<!--                                              style="margin-bottom: 5px;width: 100%">-->
<!--                                </el-progress>-->
<!--                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li style="margin-top: 16px;overflow: hidden;width: 100%">-->
<!--                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">-->
<!--                                A类-->
<!--                            </div>-->
<!--                            <div style="float: left;width: calc(100% - 50px)">-->
<!--                                <el-progress  :stroke-width="20"  :percentage="98"-->
<!--                                              style="margin-bottom: 5px;width: 100%">-->
<!--                                </el-progress>-->
<!--                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li style="margin-top: 16px;overflow: hidden;width: 100%">-->
<!--                            <div style="width: 50px;height: 20px;float: left;line-height: 20px">-->
<!--                                A类-->
<!--                            </div>-->
<!--                            <div style="float: left;width: calc(100% - 50px)">-->
<!--                                <el-progress  :stroke-width="20"  :percentage="98"-->
<!--                                              style="margin-bottom: 5px;width: 100%">-->
<!--                                </el-progress>-->
<!--                                <span style="float: right;color: #4A90E2;font-size: 12px;">目标客户总数 53人，当月已拜访 53人</span>-->
<!--                            </div>-->
<!--                        </li>-->

<!--                    </ul>-->
<!--                </div>-->
<!--            </el-col>-->
            <el-col span="24" style="margin-top: 20px">
                <el-row >
                    <el-col span="7" style="text-align: center;color: #3998f7">数据汇总</el-col>
                    <el-col span="1" style="border: 1px transparent solid;"></el-col>
                    <el-col span="7" style="text-align: center;color: #3998f7">拜访覆盖</el-col>
                    <!--                <el-col span="1" style="border: 1px transparent solid;"></el-col>-->
                    <!--                <el-col span="7" style="text-align: center;color: #3998f7">拜访达标</el-col>-->
                </el-row>
            </el-col>

        </el-row>
        <el-row style="margin-top: 20px">
            <el-table
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        prop="date"
                        label="经销商名称"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="客户等级"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="拜访次数"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="是否达标">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import inputSelect from '../../../../calendar/components/components/inputSelect'
    export default {
        name: "distributor",
        data(){
            return {
                form:{},
                tableData: [{
                    date: '王晓云',
                    name: '4',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '3',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }],
            }
        },
        components:{
            inputSelect
        },
        methods:{
            handleSelectInputClick(){

            }
        }
    }
</script>

<style scoped>
    #institution_c .custDiv_border:before{
        content:" ";
        height: 100px;
        border: 1px solid #9FA5AC;
        float: right;
        margin-top: 40px;
    }
    #institution_c >>> .el-progress-bar{
        padding-right: 60px;
    }
    #institution_c >>> .el-progress-bar__outer{
        border-radius: 2px;
    }
    #institution_c >>> .el-progress-bar__inner{
        border-radius: 2px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/customersCovered/components/distributor.vue